export const SITE_HEADER = 'Lesson Completion Snapshot'
export const SITE_HEADER_OVERVIEW_BASE = 'Lesson Completion Overview'
export const LESSON_COMPLETION_SPECIALIZED_UNITS_LABEL = 'Specialized Units'
export const LESSON_COMPLETION_SPECIALIZED_SUMMARY_TEXT =
  'Monitor progress by checking lesson completion by grade and class '
export const DIGITAL_WELL_BEING_UNIT_LABEL = 'Digital Well-Being Unit'
export const DIGITAL_WELL_BEING_UNIT_PILL_TEXT = 'Digital Well-Being Unit'
